var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSuccess = function SvgSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 75C30.7174 75 21.815 71.3125 15.2513 64.7487C8.68749 58.185 5 49.2826 5 40C5 30.7174 8.68749 21.815 15.2513 15.2513C21.815 8.68749 30.7174 5 40 5C49.2826 5 58.185 8.68749 64.7487 15.2513C71.3125 21.815 75 30.7174 75 40C75 49.2826 71.3125 58.185 64.7487 64.7487C58.185 71.3125 49.2826 75 40 75ZM40 80C50.6087 80 60.7828 75.7857 68.2843 68.2843C75.7857 60.7828 80 50.6087 80 40C80 29.3913 75.7857 19.2172 68.2843 11.7157C60.7828 4.21427 50.6087 0 40 0C29.3913 0 19.2172 4.21427 11.7157 11.7157C4.21427 19.2172 0 29.3913 0 40C0 50.6087 4.21427 60.7828 11.7157 68.2843C19.2172 75.7857 29.3913 80 40 80V80Z",
    fill: "#85E0A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2814 28.803C51.2551 28.8285 51.2304 28.8556 51.2076 28.8842L38.3846 45.2314L30.6569 37.4956C30.132 37.0062 29.4377 36.7397 28.7203 36.7524C28.0029 36.7651 27.3184 37.0558 26.8111 37.5635C26.3037 38.0711 26.0131 38.756 26.0004 39.4738C25.9878 40.1916 26.2541 40.8863 26.7432 41.4115L36.5127 51.1903C36.7759 51.4531 37.0893 51.6602 37.4342 51.7993C37.7791 51.9383 38.1485 52.0064 38.5203 51.9995C38.8921 51.9926 39.2587 51.9109 39.5982 51.7591C39.9378 51.6074 40.2433 51.3888 40.4966 51.1164L55.2357 32.6819C55.7376 32.1549 56.012 31.4514 55.9996 30.7235C55.9872 29.9956 55.689 29.3019 55.1695 28.7922C54.6499 28.2826 53.9508 27.998 53.2232 28C52.4957 28.002 51.7981 28.2905 51.2814 28.803V28.803Z",
    fill: "#85E0A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success.f917d568.svg";
export { ForwardRef as ReactComponent };